import r from "classnames";
import t, { useMemo as v } from "react";
import { ScreenReaderOnly as d } from "../utils/sr-only.esm.js";
import { ChevronButton as g } from "./chevron-button.esm.js";
import { Ellipses as E } from "./ellipses.esm.js";
import { PaginationButton as I } from "./pagination-button.esm.js";
import { getPaginationItems as N } from "./utils.esm.js";
const $ = "_pagination_jk01j_1", x = "_pagination__list_jk01j_16", y = "_pagination__listItem_jk01j_23", o = {
  pagination: $,
  pagination__list: x,
  pagination__listItem: y,
  "pagination__listItem--ellipsis": "_pagination__listItem--ellipsis_jk01j_44"
}, q = ({
  currentPage: i,
  totalPages: e,
  onChange: _,
  dataTestId: n,
  className: c,
  baseURL: l,
  ...f
}) => {
  const { items: s, prevURL: u, nextURL: j } = v(
    () => N({ currentPage: i, totalPages: e, baseURL: l }),
    [i, e, l]
  );
  return /* @__PURE__ */ t.createElement(
    "nav",
    {
      "aria-label": "Pagination",
      className: r(o.pagination, "fuse-pagination", c),
      "data-testid": n || "fuse-pagination-data-testid",
      ...f
    },
    /* @__PURE__ */ t.createElement(
      g,
      {
        currentPage: i,
        variant: "previous",
        onClick: _,
        totalPages: e,
        dataTestId: n,
        href: u
      }
    ),
    /* @__PURE__ */ t.createElement(
      "ol",
      {
        className: `${o.pagination__list} fuse-pagination__page-list`,
        "data-testid": "fuse-pagination__page-list"
      },
      s == null ? void 0 : s.map(({ page: m, href: k, isEllipsis: a, screen: p }) => /* @__PURE__ */ t.createElement(
        "li",
        {
          key: `Page-${m}-${p}`,
          "data-screen": p,
          className: r(o.pagination__listItem, {
            "fuse-pagination__list-item": !a,
            "fuse-pagination__ellipses": a,
            [o["pagination__listItem--ellipsis"]]: a
          }),
          "data-testid": a ? "fuse-pagination__ellipses" : "fuse-pagination__list-item"
        },
        a ? /* @__PURE__ */ t.createElement(E, null) : /* @__PURE__ */ t.createElement(
          I,
          {
            isCurrent: i === m,
            onClick: _,
            dataTestId: n,
            href: l && k
          },
          m
        )
      ))
    ),
    /* @__PURE__ */ t.createElement(
      g,
      {
        currentPage: i,
        variant: "next",
        onClick: _,
        totalPages: e,
        dataTestId: n,
        href: j
      }
    ),
    /* @__PURE__ */ t.createElement(d, { "aria-live": "polite" }, `Page ${i} selected`)
  );
};
export {
  q as Pagination
};
